import he from 'he';
import { Helmet } from 'react-helmet-async';
import { Redirect, useLocation } from 'react-router-dom';

import config from '../../config';
import { PREVIEW_LINK_RESOLVER } from '../../services/prismic';

import type { MetadataSliceType } from './types';

export interface MetadataSliceProps {
  slice: MetadataSliceType;
}

export const appUrl = config.get('app.websiteUrl');

export function MetadataSlice({ slice }: MetadataSliceProps) {
  const { metaDesc, noindex, titleTag, redirectLink } = slice.primary;
  const { pathname } = useLocation();
  const isPreview = pathname.startsWith(PREVIEW_LINK_RESOLVER);

  const fullCanonicalLink = `${appUrl}${pathname}`;

  if (redirectLink) {
    return <Redirect to={redirectLink} />;
  }

  return (
    <Helmet>
      <title>{he.encode(titleTag)} | The Farmer’s Dog</title>
      {!isPreview && <link rel="canonical" href={fullCanonicalLink} />}
      <meta name="description" content={metaDesc} />
      {(noindex || isPreview) && <meta name="robots" content="noindex" />}
    </Helmet>
  );
}
